export const validationEmail = (email: string): boolean => {
  const re =
    /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  return re.test(String(email)?.toLowerCase());
};

export const validationPhone = (
  number: string,
  isWithoutCityPhone?: boolean
): boolean => {
  const inputPhoneValue = number?.replace(/\D/g, '');
  const modifiedInputPhoneValue =
    inputPhoneValue &&
    (inputPhoneValue[0] === '8' || inputPhoneValue[0] === '7')
      ? inputPhoneValue
      : `8${inputPhoneValue}`;
  const isInputValid =
    !number?.includes('@') &&
    !isNaN(+modifiedInputPhoneValue) &&
    modifiedInputPhoneValue.length === 11;
  const secondLetterValidation = isWithoutCityPhone
    ? modifiedInputPhoneValue[1] === '9'
    : modifiedInputPhoneValue[1] === '9' || modifiedInputPhoneValue[1] === '4';
  return isInputValid && secondLetterValidation;
};

export const validationPass = (pass: string): boolean => pass.length > 3;
